"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreRpcRemote = void 0;
const identifiers_1 = require("../../identifiers");
const RpcRemote_1 = require("../contact/RpcRemote");
class StoreRpcRemote extends RpcRemote_1.RpcRemote {
    async storeData(request) {
        const options = this.formDhtRpcOptions();
        try {
            await this.getClient().storeData(request, options);
        }
        catch (err) {
            const to = (0, identifiers_1.toNodeId)(this.getPeerDescriptor());
            const from = (0, identifiers_1.toNodeId)(this.getLocalPeerDescriptor());
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw new Error(`Could not store data to ${to} from ${from} ${err}`);
        }
    }
    async replicateData(request, connect) {
        const options = this.formDhtRpcOptions({
            timeout: RpcRemote_1.EXISTING_CONNECTION_TIMEOUT,
            notification: true,
            connect
        });
        return this.getClient().replicateData(request, options);
    }
}
exports.StoreRpcRemote = StoreRpcRemote;
//# sourceMappingURL=StoreRpcRemote.js.map